var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Permission denied.")]),_c('h3',[_vm._v("Please write to help@opendatahub.com if you think you should be able to see this page.")])])
}]

export { render, staticRenderFns }